import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { ExternalLinkTemplateContext, RouterLinkTemplateContext } from '../../header.component';

@Component({
  selector: 'app-on-demand-user-header',
  templateUrl: './on-demand-user-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnDemandUserHeaderComponent {
  @Input()
  public externalLinkTemplate: TemplateRef<ExternalLinkTemplateContext>;

  @Input()
  public routerLinkTemplate: TemplateRef<RouterLinkTemplateContext>;

  @Input()
  public authenticatedUserLinksTemplate: TemplateRef<void>;
}
